export default "__VITE_ASSET__feT3SB0C__"